import axios from '../utils/axios';

const AUTH_CONSTANTS = {
  EXCLUDED_URLS: {
    CHANGE_PASSWORD: 'change_password',
    LOGIN: 'login',
    LOGOUT: 'logout',
    SESSIONS: 'sessions',
  },
};

/**
 * @class AuthService
 * @description Service for handling authentication operations
 */
class AuthService {
  setAxiosInterceptors({ onLogout }) {
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const isUnauthorized = error?.response?.status === 401;
        const url = error?.response?.config?.url || '';
        const isExcludedUrl = Object.values(AUTH_CONSTANTS.EXCLUDED_URLS).some(
          (excludedUrl) => url.includes(excludedUrl),
        );

        if (isUnauthorized && !isExcludedUrl && onLogout) {
          onLogout();
        }
        return Promise.reject(error);
      },
    );
  }
}

const authService = new AuthService();

export default authService;
